import React from 'react';
import './Style/TermsAndConditions.css';
import TopNavbar from './../home/TopNavbar';

const TermsAndConditions = () => {
  const lastUpdated = "August 2026";
  const contactEmail1 = "contact@mystudyplace.online";
  const contactEmail2 = "sarwar93390@gmail.com";
     
  return (
    <div className="condition-container">
      <TopNavbar name="Terms & Conditions" />


      <div className="condition-card">
        <br></br>
        <h1>Terms & Conditions</h1>
        <p className="condition-last-updated">Last Updated: {lastUpdated}</p>

        {/* --- MANDATORY GOOGLE COMPLIANCE DISCLAIMER --- */}
        <section className="condition-disclaimer-section" style={{ border: '1px solid #ddd', padding: '15px', borderRadius: '8px', marginBottom: '20px', backgroundColor: '#f9f9f9' }}>
          <h2 style={{ color: '#d9534f', fontSize: '16px' }}>Government Disclaimer</h2>
          <p>
            <strong>NEET Prep</strong> is an independent educational platform. We are <strong>not affiliated with</strong>, authorized by, or endorsed by the <strong>National Testing Agency (NTA)</strong> or any government organization.
          </p>
          <p>
            All exam patterns, syllabus structures, and updates provided are purely for educational guidance and are compiled from the official NTA website: 
            <a href="https://nta.ac.in/" target="_blank" rel="noreferrer" style={{ marginLeft: '5px', wordBreak: 'break-all' }}>
              https://nta.ac.in/
            </a>
          </p>
        </section>
        {/* ------------------------------------------ */}

        <section className="condition-section">
          <h2 className='terms-heading'>1. Acceptance of Terms</h2>
          <p>
            By downloading, installing, or registering an account on the <strong>NEET Prep</strong> mobile application, you agree to comply with and be bound by these Terms and Conditions. If you do not agree, please do not use the application.
          </p>
        </section>

        <section className="condition-section">
          <h2 className='terms-heading'>2. User Accounts & Security</h2>
          <p>
            While core browsing is accessible as a guest, creating an account requires basic identifiers (Name, Email, Phone Number, and Academic Class Tier). You are entirely responsible for maintaining the confidentiality of your session tokens and verification details. 
          </p>
        </section>

        <section className="condition-section">
          <h2 className='terms-heading'>3. Intellectual Property Rights</h2>
          <p>
            All application interfaces, structured test formats, daily practice problems (DPPs), performance analytics layouts, and proprietary compilation materials within <strong>NEET Prep</strong> are the intellectual property of the platform. You may not scrape, copy, modify, distribute, or reverse-engineer any portion of the app code or question databases.
          </p>
        </section>

        <section className="condition-section">
          <h2 className='terms-heading'>4. Platform Usage & Restrictions</h2>
          <p>
            This application is built solely for individual, non-commercial educational use by medical aspirants. Any automated access, excessive data querying, or behavior that disrupts the backend database infrastructure will result in immediate termination of account access.
          </p>
        </section>

        {/* --- IN-APP PURCHASES, PAYMENT FAILURES & REFUND POLICY --- */}
        <section className="condition-section">
          <h2 className='terms-heading'>5. Payments, Subscriptions & Refund Policy</h2>
          <p>
            Certain features, premium mock test series, and study materials inside <strong>NEET Prep</strong> require paid subscriptions or one-time purchases through <strong>Google Play Billing</strong>.
          </p>

          <h3>5.1 Payment Processing</h3>
          <p>
            All purchases are processed securely via Google Play. We do not handle or store credit/debit card details, UPI IDs, or banking credentials on our platform.
          </p>

          <h3>5.2 Failed Transactions & Automatic Refunds</h3>
          <p>
            If money is deducted from your bank account or wallet but the transaction fails within the app, <strong>Google Play or your bank will automatically process a full refund</strong> back to your original payment method within 3 to 5 business days.
          </p>

          <h3>5.3 Payment Debited but Content Not Unlocked</h3>
          <p>
            If your payment was successful but your premium content or subscription is not activated within the app, please contact our support team at <strong>{contactEmail1}</strong> or <strong>{contactEmail2}</strong> with your Google Play Order ID (e.g., <code>GPA.XXXX-XXXX-XXXX-XXXXX</code>). Our team will manually verify the purchase and activate your content immediately.
          </p>

          <h3>5.4 Subscription & Refund Policy</h3>
          <p>
            All digital subscriptions, test series packages, and premium content purchases are <strong>final and non-refundable</strong> once access to the content has been granted.
          </p>
        </section>

        <section className="condition-section">
          <h2 className='terms-heading'>6. Limitation of Liability</h2>
          <p>
            While we strive for absolute accuracy in our mock test banks, previous year question records, and weightage data, <strong>NEET Prep</strong> provides materials on an "as-is" basis. We do not guarantee specific scores or performance results in the final official NTA NEET examination.
          </p>
        </section>

        <section className="condition-section">
          <h2 className='terms-heading'>7. Termination of Service</h2>
          <p>
            We reserve the right to suspend or terminate user profiles that violate these terms. Furthermore, users can choose to remove their presence completely at any point by executing the <strong>"Delete Account"</strong> tool directly from their in-app profile control panel.
          </p>
        </section>

        <section className="contact-section">
          <h2 className='terms-heading'>8. Contact Information</h2>
          <p>For clarifications regarding these Terms &amp; Conditions or payment-related assistance, please contact us at:</p>
          Email: <a href={`mailto:${contactEmail1}`} className="email-button">
            {contactEmail1}
          </a> <br />
          Gmail: <a href={`mailto:${contactEmail2}`} className="email-button">
            {contactEmail2}
          </a> <br /><br />
        </section>

      </div>
    </div>
  );
};

export default TermsAndConditions;